/* eslint-disable no-console */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store';

import Home from '@/views/Home'
import Performance from '@/views/Performance'
import PastPerformance from '@/views/PastPerformance'
import About from '@/views/About'
import JoinUs from '@/views/JoinUs'
import Blog from '@/views/Blog'
import Contact from '@/views/Contact'
import UpdateInfoDetail from '@/views/UpdateInfoDetail'

var Auth = {
  loggedIn: false,
  login: function() {
    this.loggedIn = true;
    console.log("loggedIn");
  },
  logout: function() {
    this.loggedIn = false;
    console.log("logout");
  },
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: 'たちかわ演劇祭',
      },
    },
    {
      path: '/index.html',
      component: Home,
      meta: {
        title: 'たちかわ演劇祭',
      },
    },
    {
      path: '/home',
      component: Home,
      meta: {
        title: 'たちかわ演劇祭',
      },
    },
    {
      path: '/performance',
      component: Performance,
      meta: {
        title: '公演情報 | たちかわ演劇祭',
      },
    },
    {
      path: '/pastperformance',
      component: PastPerformance,
      meta: {
        title: '過去の公演情報 | たちかわ演劇祭',
      },
    },
    {
      path: '/about',
      component: About,
      meta: {
        title: 'たちかわ演劇祭について | たちかわ演劇祭',
      },
    },
    {
      path: '/joinus',
      component: JoinUs,
      meta: {
        title: '参加団体募集 | たちかわ演劇祭',
      },
    },
    {
      path: '/blog',
      component: Blog,
      meta: {
        title: 'ブログ | たちかわ演劇祭',
      },
    },
    {
      path: '/blog/:postDate',
      component: Blog,
      meta: {
        title: 'ブログ | たちかわ演劇祭',
      },
    },
    {
      path: '/contact',
      component: Contact,
      meta: {
        title: 'お問い合わせ | たちかわ演劇祭',
      },
    },
    {
      path: '/updateinfodetail',
      component: UpdateInfoDetail,
      meta: {
        title: '更新情報 | たちかわ演劇祭',
      },
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !Auth.loggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath }})
  } else {
    next()
  }
})

export default router

router.afterEach((to) =>{
  if (to.meta && to.meta.title) {
    store.dispatch('common/changePage', to.meta.title)
  }
})
